module.exports = __webpack_public_path__ + "img/logo_wlrc_full.111b2996.png";